import React from 'react';
import PropTypes from 'prop-types';

import './TrendingIcon.scss';

const TrendingIcon = ({ isActive }) => {
    const activeStyle = isActive ? 'active' : '';
    return (
        <svg
            className={`component-TrendingIcon ${activeStyle}`}
            fill="none"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                className="trending-fill-outline"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.1469 8.24156C17.5377 9.41417 18.3332 10.8519 18.3332 12.8237C18.3332 16.9317 15.0454 20.1666 11.0104 20.1666C6.97175 20.1666 3.6665 16.9295 3.6665 12.8237C3.6665 10.5625 4.16845 9.16505 5.64194 6.8422C6.10818 6.10719 7.24029 6.37486 7.328 7.24085C7.40682 8.01898 7.64882 8.68134 8.00142 9.18915C7.76624 6.4452 8.98658 3.35924 11.9956 1.89316C12.6923 1.55374 13.4696 2.17821 13.2884 2.93164C12.8186 4.88421 13.3026 5.93469 14.5679 7.06636C14.5987 7.09396 14.7563 7.20756 14.9648 7.35781C15.3424 7.6299 15.8867 8.02217 16.1469 8.24156ZM6.0689 9.85849C5.8106 10.4455 5.49988 11.1516 5.49988 12.8237C5.49988 15.9083 7.97586 18.3332 11.0104 18.3332C14.0395 18.3332 16.4999 15.9124 16.4999 12.8237C16.4999 11.4457 15.9725 10.4924 14.9652 9.64321C14.8062 9.50917 14.4336 9.23854 14.0828 8.98382C13.7511 8.74297 13.439 8.51635 13.3457 8.43282C12.131 7.34636 11.3884 6.1894 11.2875 4.64667C10.6733 5.24537 9.2621 7.1066 10.0575 10.7901C10.1808 11.3611 9.7457 11.9002 9.16151 11.9002C8.00243 11.9002 6.85669 11.0138 6.15646 9.65686C6.12837 9.72335 6.09899 9.79011 6.0689 9.85849Z"
                fill="#566D96"
            />
            <path
                className="trending-fill-color"
                d="M10.9999 4.49994C9.96255 4.96922 9.86812 5.92256 9.49991 6.99994C8.93157 8.66286 9.49991 11.4999 9.49991 11.4999C9.49991 11.4999 7.33329 8.66307 5.99991 9.49994C5.10927 10.0589 5.16288 10.9611 4.99991 11.9999C4.68394 14.0139 5.03577 15.5814 6.49991 16.9999C7.69811 18.1608 8.85326 18.2319 10.4999 18.4999C11.849 18.7196 12.7477 19.0478 13.9999 18.4999C15.3971 17.8887 15.9442 16.9201 16.4999 15.4999C17.1403 13.8634 17.2522 12.5881 16.4999 10.9999C15.9088 9.75214 14.9172 9.5319 13.9999 8.49994C12.7027 7.04054 12.779 3.69514 10.9999 4.49994Z"
                fill="#566D96"
                stroke="#566D96"
            />
        </svg>
    );
};
TrendingIcon.propTypes = {
    isActive: PropTypes.bool,
};

TrendingIcon.defaultProps = {
    isActive: false,
};

TrendingIcon.displayName = 'TrendingIcon';

export default TrendingIcon;
